export default __webpack_public_path__ + "static/media/icon-ic-address-book-menu.15c462fa.svg";